/**
 * Recommend 页面公共配置
 * 所有品牌共享的文案
 */

export const commonTexts = {
  end: 'END',
  ongoing: 'ONGOING',
  endDescription: 'This book has been completed',
  ongoingDescription: 'The book is being updated with all efforts',
  youMightAlsoLike: 'You Might Also Like',
  more: 'More',
  loading: 'Loading...',
  failedToLoad: 'Failed to load recommendations',
} as const

export const recommendCommonConfig = {
  texts: commonTexts,
}
